import React from 'react'
import styled, { css } from 'styled-components'

export const Container = styled.div<{ $align: string; $flex?: number }>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: ${({ $align }) => $align};
    ${({ $flex }) =>
        $flex &&
        css`
            flex: ${$flex};
        `}
`

export const Column: React.FC<{
    align?: string
    flex?: number
    style?: React.CSSProperties
    className?: string
}> = ({ children, align = 'flex-start', flex, style, className }) => {
    return (
        <Container $align={align} $flex={flex} style={style} className={className}>
            {children}
        </Container>
    )
}
